import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { CountdownTimeComponent } from '../countdown-time/countdown-time.component';

@Component({
  selector: 'mb-countdown-time-fields',
  templateUrl: './countdown-time-fields.component.html',
  styleUrls: ['./countdown-time-fields.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CountdownTimeComponent, TranslatePipe],
})
export class CountdownTimeFieldsComponent {
  @Input() days!: number;
  @Input() hours!: number;
  @Input() minutes!: number;
  @Input() seconds!: number;

  @Input() hideRedundant = false;
}
